import { data as constants } from "../../constants";
import { db, collection, getDocs, doc, updateDoc, arrayUnion } from "../../firebase";
import { Log } from "../entities/log";
import LogRepository from "../usecases/ports/logRepository";

export default class LogsFirebaseImpl implements LogRepository {
  updateLog = async (applicantId: string, log: Log): Promise<void> => {
    try {
      let logId: string = "";
      const applicantLogsRef = collection(db, "applicant", applicantId, "logs");
      const applicantLogsDocData = await getDocs(applicantLogsRef);
      if (applicantLogsDocData.empty && applicantLogsDocData.metadata.fromCache) {
        throw new Error(constants.commonNetworkError);
      }
      logId = applicantLogsDocData.docs[0].id;
      const applicantLogRef = doc(db, "applicant", applicantId, "logs", logId);
      await updateDoc(applicantLogRef, {
        logs: arrayUnion(log),
      });
    } catch (error) {
      throw error;
    }
  };

  getLogs = async (applicantId: string): Promise<any> => {
    try {
      let logs: Array<any> = [];
      const logsRef = collection(db, "applicant", applicantId, "logs");
      const logsDocData = await getDocs(logsRef);
      if (logsDocData.empty && logsDocData.metadata.fromCache) {
        throw new Error(constants.commonNetworkError);
      }
      logsDocData.forEach((doc) => {
        let data = doc.data();

        const formattedData = data.logs
          .map((logData: any) => {
            return {
              dateTime: logData.dateTime.toDate(),
              editor: logData.editor,
              status: logData.status,
            };
          })
          .sort((a: any, b: any) => b.dateTime - a.dateTime);

        logs.push({ logs: formattedData, id: doc.id });
      });
      return logs[0];
    } catch (error) {
      throw error;
    }
  };
}
